import { render, staticRenderFns } from "./DiagnosesGroup.vue?vue&type=template&id=339419f8&scoped=true"
import script from "./DiagnosesGroup.vue?vue&type=script&lang=ts"
export * from "./DiagnosesGroup.vue?vue&type=script&lang=ts"
import style0 from "./DiagnosesGroup.vue?vue&type=style&index=0&id=339419f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339419f8",
  null
  
)

export default component.exports